import $ from 'jquery'

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {

    let arrButtons = $('.switch-btn'),
      arrTables = $('.switch-table');

    function getTabFromGetRequest() {
      var getParams = window.location.search;
      var params = getParams.substring(getParams.indexOf('?') + 1);

      var arrParams = params.split('&');

      for(var i = 0; i < arrParams.length; i++){
        if(arrParams[i].split('=')[0] === 'tab') return arrParams[i].split('=')[1];
      }
    }

    function switchTabRequest() {
      var tab = getTabFromGetRequest();
      if(tab === '1'){
        console.log('1');
        $('.switch-btn').eq(0).trigger('click');
      }
      else if(tab === '2'){
        console.log('2');
        $('.switch-btn').eq(1).trigger('click');
      }
      else if(tab === '3'){
        console.log('3');
        $('.switch-btn').eq(2).trigger('click');
      }
    }

    function switchingTabs(arrButtons, arrTables) {
      return function () {
        let context = $(this)[0];
        for (let i = 0; i < arrButtons.length; i++) {
          if (arrButtons[i] !== context) {
            $(arrButtons[i]).removeClass('switch-btn-active');
            $(arrTables[i]).removeClass('switch-table-active');
          } else {
            $(arrButtons[i]).addClass('switch-btn-active');
            $(arrTables[i]).addClass('switch-table-active');
          }
        }
      };
    }

    for (let i = 0; i < arrButtons.length; i++) {
      $(arrButtons[i]).on('click', switchingTabs(arrButtons, arrTables));
    }
    switchTabRequest();
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/pageTemplateExchangeRate.js